import { MouseEvent, memo } from 'react';

import { Box } from '@material-ui/core';
import { RejectButton, ApplyButton, Loader } from 'components';

import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  borderClassName?: string;
  title: {
    className?: string;
    text: string;
  };
  applyButton: {
    className?: string;
    loader?: boolean;
    click: (e?: MouseEvent<HTMLButtonElement>) => void | Promise<void>;
    text: string;
    disabled?: boolean;
  };
  rejectButton: {
    className?: string;
    loader?: boolean;
    click: (e?: MouseEvent<HTMLButtonElement>) => void | Promise<void>;
    text: string;
    disabled?: boolean;
  };
}

const Confirmation = ({
  title,
  applyButton,
  rejectButton,
  borderClassName,
}: Props) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <p className={clsx(classes.title, title.className)}>{title.text}</p>
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="flex-end"
        width="100%"
        className={borderClassName}
      >
        <RejectButton
          className={clsx(classes.rejectBtn, rejectButton.className)}
          onClick={rejectButton.click}
          disabled={rejectButton.disabled}
        >
          {rejectButton.text}
          {rejectButton.loader ? (
            <Loader size={17} cls={{ root: classes.loader }} />
          ) : null}
        </RejectButton>
        <ApplyButton
          className={applyButton.className}
          onClick={applyButton.click}
          disabled={applyButton.disabled}
        >
          {applyButton.text}
          {applyButton.loader ? (
            <Loader size={17} cls={{ root: classes.loader }} />
          ) : null}
        </ApplyButton>
      </Box>
    </Box>
  );
};

export default memo(Confirmation);
